

export function isNumber(value: string): Error | undefined {
  const re = /^[0-9\b]+$/;
  if (!re.test(value)) {
    return new Error("Invalid number");
  }
}
